// extracted by mini-css-extract-plugin
export var RecruitInformation = "RecruitInformation-module--RecruitInformation--r8VHs";
export var RecruitInformation__inner = "RecruitInformation-module--RecruitInformation__inner--1lkES";
export var RecruitInformation__content = "RecruitInformation-module--RecruitInformation__content--I4Ry9";
export var RecruitInformation__title = "RecruitInformation-module--RecruitInformation__title--11qVe";
export var RecruitInformation__table = "RecruitInformation-module--RecruitInformation__table--3cYFF";
export var div = "RecruitInformation-module--div--1dlu_";
export var dt = "RecruitInformation-module--dt--xhv-j";
export var dd = "RecruitInformation-module--dd--N3zbz";